module.exports = __webpack_public_path__ + "img/web-p2-t4.5b7bd7df.svg";